var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPassword = function SvgIconPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 4.25a1 1 0 0 1 1 1v13.5a1 1 0 1 1-2 0V5.25a1 1 0 0 1 1-1M9.75 8a1 1 0 0 1 1 1v1.623l1.54-.502a1 1 0 0 1 .62 1.902l-1.543.502.955 1.316a1 1 0 0 1-1.619 1.175l-.953-1.314-.953 1.314a1 1 0 0 1-1.619-1.175l.955-1.316-1.542-.502a1 1 0 1 1 .619-1.902l1.54.501V9a1 1 0 0 1 1-1M19.75 9a1 1 0 1 0-2 0v1.622l-1.54-.501a1 1 0 0 0-.62 1.902l1.543.502-.955 1.316a1 1 0 0 0 1.619 1.175l.953-1.314.953 1.314a1 1 0 0 0 1.619-1.175l-.955-1.316 1.543-.502a1 1 0 1 0-.62-1.902l-1.54.502z"
  }))));
};
export default SvgIconPassword;